export var TagColorVariant;
(function (TagColorVariant) {
    TagColorVariant[TagColorVariant["LIGHT_GREY"] = 0] = "LIGHT_GREY";
    TagColorVariant[TagColorVariant["GREY"] = 1] = "GREY";
    TagColorVariant[TagColorVariant["DARK_GREY"] = 2] = "DARK_GREY";
})(TagColorVariant || (TagColorVariant = {}));
//# sourceMappingURL=Tag.enum.js.map